import { z } from "zod";

import { ibanSchema } from "@/lib/validation/commission.schemas";

export const createShopInfoSchema = z.object({
  name: z.string().min(1, { error: "نام فروشگاه الزامی است" }),
  category: z.string().optional(),
  business_type: z.string().optional(),
  warehouse_address: z.string().optional(),
  description: z.string().optional(),
  iban: ibanSchema,
});

export type CreateShopInfoFormValues = z.infer<typeof createShopInfoSchema>;

export const createShopInviteSchema = z.object({
  phone: z
    .string()
    .min(1, { error: "شماره موبایل الزامی است" })
    .regex(/^09\d{9}$/, { error: "شماره موبایل باید با 09 شروع و ۱۱ رقم باشد" }),
});

export type CreateShopInviteFormValues = z.infer<typeof createShopInviteSchema>;

